import { render, staticRenderFns } from "./WinnerBoardHeader.vue?vue&type=template&id=1e5c018a&scoped=true"
import script from "./WinnerBoardHeader.vue?vue&type=script&lang=js"
export * from "./WinnerBoardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5c018a",
  null
  
)

export default component.exports